import { IndicatorApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeIndicators } from './normalizers';
import { Indicator } from './types';

export class VoladeumIndicators extends Axios {
  async list(): Promise<VoladeumResponse<Indicator[]>> {
    const res = await this.get<VoladeumResponse<IndicatorApi[]>>('/v1/lookups/indicators');
    return {
      success: res.success,
      error: res.error,
      data: normalizeIndicators(res.data),
    };
  }
}
